import { Routes } from '@angular/router';
import { CookieSettingsGuard } from '@teamfoster/sdk/cookie-ngrx';
import { DictionaryGuard } from '@teamfoster/sdk/dictionary-ngrx';
import { MenuGuard } from '@teamfoster/sdk/menu-ngrx';

import { LocationGuard } from './location/guards';
import { SocialChannelsGuard } from './social-media/guards';
import { menuThemeGuard, resetMenuThemeGuard } from './guards/menu-theme.guard';

const appGuards = [CookieSettingsGuard, DictionaryGuard, MenuGuard, LocationGuard, SocialChannelsGuard, menuThemeGuard];

export const routes: Routes = [
  {
    path: 'narrowcasting',
    loadComponent: () => import('./layouts/empty-layout/empty-layout.component').then(m => m.EmptyLayoutComponent),
    canActivate: [DictionaryGuard],
    pathMatch: 'prefix',
    children: [
      {
        path: '',
        loadChildren: () => import('./narrowcasting/narrowcasting.routes').then(m => m.routes),
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('./layouts/website-layout/website-layout.component').then(m => m.WebsiteLayoutComponent),
    pathMatch: 'prefix',
    canActivate: [...appGuards],
    children: [
      {
        path: 'styleguide',
        loadChildren: () => import('./styleguide/styleguide.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'contentblokken',
        pathMatch: 'prefix',
        loadChildren: () => import('./content-blocks/content-blocks.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
        data: {
          reuseComponent: true,
        },
      },
      {
        path: 'agenda',
        loadChildren: () => import('./events/events.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'pagina',
        loadChildren: () => import('./content/content.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'nieuws',
        loadChildren: () => import('./news/news.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'faq',
        loadChildren: () => import('./faq/faq.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'museum/collecties',
        loadChildren: () => import('./museum-collections/museum-collections.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'zoeken',
        loadChildren: () => import('./search/search.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: 'pressroom',
        loadChildren: () => import('./press-room/press-room.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: '404',
        loadComponent: () => import('./404.component').then(m => m.NotFoundComponent),
      },
      {
        path: '',
        pathMatch: 'prefix',
        loadChildren: () => import('./landing-pages/landing-pages.routes').then(m => m.routes),
        canDeactivate: [resetMenuThemeGuard],
      },
      {
        path: '**',
        redirectTo: '/404',
      },
    ],
  },
];
